import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=5c656db8&"
import script from "./Basic.vue?vue&type=script&lang=js&"
export * from "./Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c656db8')) {
      api.createRecord('5c656db8', component.options)
    } else {
      api.reload('5c656db8', component.options)
    }
    module.hot.accept("./Basic.vue?vue&type=template&id=5c656db8&", function () {
      api.rerender('5c656db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/dashboard/Basic.vue"
export default component.exports